import EventHandler from '@pixelunion/events';
import { transition } from '@pixelunion/animations';

import NavDesktopMenu from './NavDesktopMenu'; // eslint-disable-line import/no-cycle

export default class NavDesktopParent {
  constructor(el, options) {
    this.listitem = el;
    this.link = null;
    this.submenu = null;
    this._isOpen = false;
    this._isMeganav = false;
    this.menu = null;
    this.parentMenu = options.parentMenu;
    this.closeSiblings = this.parentMenu.closeSiblings;

    this.details = el.querySelector('[data-nav-desktop-details]');
    this.events = new EventHandler();

    const { children } = this.details;

    for (let i = 0; i < children.length; i++) {
      if (children[i].dataset.navDesktopLink !== undefined) {
        this.link = children[i];
      } else if (children[i].dataset.navDesktopSubmenu !== undefined) {
        this.submenu = children[i];
      }
    }

    this.animation = transition({ el: this.submenu, state: 'closed' });

    this.open = () => {
      this._open();
      this.details.open = true;
    };
    this.close = () => {
      this._close();
    };
    this.closeEsc = e => {
      if (e.key === 'Escape') {
        this.link.focus();
        this.close();
      }
    };

    this.closeTimer = null;
    this.mouseover = () => {
      clearTimeout(this.closeTimer);
      this.open();
    };

    this.mouseout = () => {
      this.closeTimer = setTimeout(this.close, 400);
    };

    this.click = e => {
      e.stopPropagation();

      const clickedParent = e.target.closest('[data-nav-desktop-link]');
      // If the link being clicked is a parent link, then take control of the navigation
      if (clickedParent && clickedParent.dataset.href) {
        e.preventDefault();
        // if already open, continue to link destination
        if (this._isOpen) {
          window.location = clickedParent.dataset.href;
          return;
        }
        // If the submenu isn't open, open it
        this.open();
      }
    };

    this.focusin = e => {
      e.stopPropagation();
      this.closeSiblings(this);
    };

    this.events.register(this.listitem, 'mouseover', () => this.mouseover());
    this.events.register(this.listitem, 'mouseout', () => this.mouseout());
    this.events.register(this.details, 'touchend', e => this.click(e));
    this.events.register(this.details, 'click', e => this.click(e));
    this.events.register(this.listitem, 'focusin', e => this.focusin(e));

    this.events.register(document.body, 'click', () => this.close());
    this.events.register(document.body, 'focusin', () => this.close());
  }

  get isOpen() {
    return this._isOpen;
  }

  get isMeganav() {
    return this.submenu.classList.contains('navigation-meganav');
  }

  get blockId() {
    return this.submenu.dataset.meganavId;
  }

  forceOpen() {
    return this._open(true);
  }

  forceClose() {
    return this._close(true);
  }

  _open() {
    if (this._isOpen) return;

    this._isOpen = true;
    this.closeSiblings(this);

    this.closeEscEvent = this.events.register(window, 'keydown', e => this.closeEsc(e));

    if (!this.menu && !this.submenu.classList.contains('navigation-meganav')) {
      this.menu = new NavDesktopMenu(this.submenu);
    }

    this.animation.animateTo('open', {
      hold: true,
      onStart: () => {
        this.submenu.classList.remove('alternate-drop');
        // Check for if dropdown is offscreen and style accordingly
        const menuBounds = this.submenu.getBoundingClientRect();
        if (menuBounds.right > document.documentElement.clientWidth) {
          this.submenu.classList.add('alternate-drop');
        }
      },
    })
      .then(state => {
        if (state === 'open') {
          this.link.setAttribute('aria-expanded', true);
        }
      });
  }

  _close() {
    if (!this._isOpen) return;

    if (this.menu) {
      this.menu.unload();
      this.menu = null;
    }

    this._isOpen = false;

    this.events.unregister(this.closeEscEvent);

    this.animation.animateTo('closed')
      .then(state => {
        if (state === 'closed') {
          this.submenu.classList.remove('alternate-drop');
          this.link.setAttribute('aria-expanded', false);
          this.parentMenu.openSelectedBlock();
          this.details.open = false;
        }
      });
  }

  unload() {
    this.forceClose();
    this.events.unregisterAll();

    window.removeEventListener('keydown', this.closeEsc);

    this.animation.unload();
  }
}
